export const getUserData = (storageKey = 'user'): any => {
  if (typeof window === 'undefined') return null; // SSR guard
  
  try {
    const userData = localStorage.getItem(storageKey);
    if (!userData) return null;

    return JSON.parse(userData);
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};
